import React from 'react';
import './About.css';
import siteContent from '../../data/siteContent';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-section__inner">
        <div className="about-section__intro">
          <h2 className="about-section__title">{siteContent.about.title}</h2>
        </div>

        <div className="about-section__content">
          {siteContent.about.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;